(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shipping-estimate"] && !Shopify.designMode) return;
  try {
    /* Delegated so the cart drawer keeps working after it re-renders its markup. */
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-shipping-estimate-country]');
    if (!select || !select.form) return;
    /* Do not disable the select before submitting: disabled controls are left out of the form data. */
    select.form.submit();
  });
  } catch(e) { console.error(e); }
})();

})();
